import React from 'react'
import { NavbarTwo } from '../components/Layout/Navbar'
import Footer from '../components/Layout/Footer'
import ContactForm from '../components/Contact/ContactForm'
import ContactBreadcrub from '../components/Contact/ContactBreadcrub'
import ContactInfo from '../components/Contact/ContactInfo'

const ContactPage = () => {
  return (
    <div>
        <NavbarTwo />
        <div className='2xl:pt-[90px] pt-[50px] xl:pt-[80px] lg:pt-[70px]'>
        <ContactBreadcrub />
        <ContactInfo />
        <ContactForm />
        <Footer/>
        </div>
    </div>
  )
}

export default ContactPage;
